import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import useClusterRegistrationsStore from '@/common/store/pinia/clusterRegistrations';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const getDcUrlFromRegistration = (registrationUuid: ID): string | undefined => {
  const clusterRegistrationsStore = useClusterRegistrationsStore();
  return clusterRegistrationsStore.getItemById(registrationUuid)?.dc_url;
};

const clusterRegistrationMap: TaskMap = {
  [TaskName.CLUSTER_REGISTRATION_CREATE]: {
    [TaskState.SUCCESS]: ({ payload: { dc_url } }) => ({
      title: i18n.t('Cloud registration added'),
      message: dc_url,
    }),
    [TaskState.RUNNING]: ({ payload: { dc_url } }) => ({
      title: i18n.t('Adding cloud registration...'),
      message: dc_url,
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to add cloud registration'),
      message: error,
    })
  },
  [TaskName.CLUSTER_REGISTRATION_TEST_CONNECTION]: {
    [TaskState.SUCCESS]: ({ payload }) => ({
      title: i18n.t('Connection successful'),
      message: payload.registration_uuid ? getDcUrlFromRegistration(payload.registration_uuid) : undefined,
    }),
    [TaskState.RUNNING]: ({ payload }) => ({
      title: i18n.t('Checking connection...'),
      message: payload.registration_uuid ? getDcUrlFromRegistration(payload.registration_uuid) : undefined,
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Connection failed'),
      message: error,
    })
  },
};

export default clusterRegistrationMap;
